"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgUmbrella01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12 1C6.52 1 1.979 5.005 1.139 10.248l-.015.09c-.061.372-.142.86.048 1.367.157.415.494.812.88 1.032.278.159.555.217.804.242.216.021.466.021.709.021H11v6.4c0 1.95 1.53 3.6 3.5 3.6s3.5-1.65 3.5-3.6a1 1 0 1 0-2 0c0 .921-.708 1.6-1.5 1.6s-1.5-.679-1.5-1.6V13h7.435c.243 0 .493 0 .709-.021.25-.025.526-.083.804-.242.386-.22.723-.617.88-1.032.19-.506.11-.995.048-1.367l-.015-.09C22.021 5.005 17.48 1 12 1Z", fill: "currentColor" }) }))); };
exports.default = SvgUmbrella01;
